export default "__VITE_ASSET__Xx$EHp0H3yxQJFU0th7n8Q__"